import { ApplicationConfig, provideBrowserGlobalErrorListeners, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {authInterceptor} from "./core/interceptors/auth.interceptor";
import {errorInterceptor} from "./core/interceptors/error.interceptor";
import {ApiConfiguration} from "./api/api-configuration";
import {environment} from "../environments/environment";

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes,withComponentInputBinding()),
        { provide: LocationStrategy,useClass: PathLocationStrategy },
        {
            provide: ApiConfiguration,
            useValue: Object.assign(new ApiConfiguration(), { rootUrl: environment.apiUrl }),
        },
        provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        provideHttpClient(
            withInterceptors([authInterceptor, errorInterceptor])
        )
    ]
};